import { useLocalStorage } from '@uidotdev/usehooks';
import { Outlet, useNavigate } from 'react-router';
import { LoginResponseData } from '@EHSNavigator/backend';
import InfoContent from './components/InfoContent';
import WarningIcon from './assets/icons/warning-icon.svg?react';

const AdminRoute = () => {
  const navigate = useNavigate();
  const [userInfo] = useLocalStorage<LoginResponseData | null>(
    'userInfo',
    null,
  );

  if (!userInfo) {
    return null;
  }

  // Check if user is app owner from user object or permissions
  const isAppOwnerFromUser = (userInfo?.user as any)?.isAppOwner === true;
  
  // Also check permissions for isAppOwner
  const isAppOwnerFromPermissions = userInfo?.user?.role?.permissions?.some(
    (permission) => permission?.name === 'isAppOwner' || permission?.name === '/admin/customers'
  );

  const isAppOwner = isAppOwnerFromUser || isAppOwnerFromPermissions || false;

  return isAppOwner ? (
    <Outlet />
  ) : (
    <div className="flex w-full flex-1 flex-col items-center justify-center">
      <InfoContent
        icon={<WarningIcon className="h-100 w-100 lg:h-150 lg:w-150" />}
        title="Access denied"
        description="You need to be an App Owner to access this page."
        buttonLabel="Go to Dashboard"
        warn
        otherClasses=""
        handleClick={() => navigate('/dashboard')}
      />
    </div>
  );
};

export default AdminRoute;

